export const isServer = typeof window === 'undefined'
export const isDev = process.env.NEXT_PUBLIC_APP_ENV !== 'production'
export const isProd = process.env.NEXT_PUBLIC_APP_ENV === 'production'
export const apiUrl = process.env.NEXT_PUBLIC_API_URL
